module.exports = __webpack_public_path__ + "img/tab.0924f537.png";